import oRequest from "@ali/request-olympics";
import {getAppendHeader} from '../../service/base'

export default function initRequestParam(defaultParams) {
  const enableCsrf = () => {
    const params = {};
    /**
     * 支持 2 种设置 csrf 的方式
     * 1. 放置于头部的 meta 中：
     *    <meta content="_csrf" name="csrf-param" />
     *    <meta content="******" name="csrf-token" />
     * 2. 放置于脚本中：
     *    <script>
     *      window.csrfToken = {
     *        tokenName: '_csrf',
     *        tokenValue: '*****',
     *      };
     *    </script>
     */

    // get token in header meta
    const metas = document.getElementsByTagName("meta");
    let metaCsrfToken;
    let metaCsrfParam;
    for (let i = 0, len = metas.length; i < len; i += 1) {
      const metaName = metas[i].getAttribute("name");
      if (metaName === "csrf-token") {
        metaCsrfToken = metas[i].getAttribute("content");
      } else if (metaName === "csrf-param") {
        metaCsrfParam = metas[i].getAttribute("content");
      }
    }

    if (metaCsrfToken && metaCsrfParam) {
      params.enableCsrf = true;
      params.csrfToken = {
        tokenName: metaCsrfParam,
        tokenValue: metaCsrfToken,
      };
    } else if (window.csrfToken) {
      params.enableCsrf = true;
      params.csrfToken = window.csrfToken;
    }

    return params;
  };

  // 创建一个中间件
  const myMiddleware = {
    // 插入请求的中间件，负责处理 request 参数
    request: (ctx) => {
      if (defaultParams) {
        ctx.req.params.params = Object.assign(
          {},
          defaultParams,
          ctx.req.params.params
        );
      }
      const appendHeader = getAppendHeader();
      if(appendHeader) {
        ctx.req.params.headers = Object.assign(
          {},
          appendHeader,
          ctx.req.params.headers
        );
      }
      return ctx;
    },
  };

  oRequest.middlewares.use(myMiddleware);
  Object.assign(oRequest.defaults, enableCsrf(), {
    timeout: 60000,
    type: "text",
  });
}
